import { SleepItem } from '@/backend/store/store';
import {
  add,
  Duration,
  formatDistance,
  formatDuration as formatDurationFns,
  formatRelative,
  intervalToDuration,
} from 'date-fns';
import { DateTime } from 'luxon';

export const relativeDate = (date: Date, baseDate = new Date()) => {
  return formatRelative(date, baseDate);
};

export const relativeDistance = (date: Date, baseDate = new Date()) => {
  return formatDistance(date, baseDate, {
    addSuffix: true,
  });
};

export const relativeDuration = (date: Date, baseDate = new Date()) => {
  const duration = intervalToDuration({
    start: date,
    end: baseDate,
  });
  return formatDurationFns(duration);
};
export const dateFilterAfter = (daysAgo: number) => {
  const date = DateTime.now().minus({ days: daysAgo }).startOf('day');
  return daysAgo ? date.toUTC().toISO()?.replace('T', ' ') : null;
};
export const addDurations = (duration1: Duration, duration2: Duration) => {
  const baseDate = new Date(0); // can probably be any date, 0 just seemed like a good start

  return intervalToDuration({
    start: baseDate,
    end: add(add(baseDate, duration1), duration2),
  });
};

export const totalDuration = (durations: Duration[]) => {
  return durations.reduce(addDurations, {
    years: 0,
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
};

export const getSleepDuration = (sleep: SleepItem) => {
  const start = new Date(sleep.start);
  const end = new Date(sleep.end || new Date());
  return intervalToDuration({ start, end });
};

export const formatDuration = (duration: Duration) => {
  return formatDurationFns(duration);
};

export const totalSleepDurationFormatted = (sleeps: SleepItem[]) => {
  return formatDuration(totalDuration(sleeps.map(getSleepDuration)));
};
